<template>
  <section v-loading="loading" class="view-stack billing-page">
    <article class="dashboard-panel billing-section">
      <div class="panel-heading billing-section-heading">
        <div>
          <h2>套餐列表</h2>
        </div>
      </div>

      <section
        v-if="packages.length"
        class="package-grid billing-package-grid"
      >
        <article
          v-for="item in packages"
          :key="item.id"
          class="package-card billing-package-card"
          :class="{ active: selectedPackageId === item.id }"
          @click="selectedPackageId = item.id"
        >
          <h3 class="billing-package-name">{{ item.packageName || (isDayCard(item) ? '日卡套餐' : '余额套餐') }}</h3>
          <p class="billing-package-description">{{ item.description || '' }}</p>
          <div class="billing-price-block">
            <span class="billing-price-label">购买金额</span>
            <strong>{{ formatPrice(item.saleAmount) }}</strong>
          </div>
          <ul class="billing-feature-list">
            <li v-for="feature in getFeatures(item)" :key="feature">{{ feature }}</li>
          </ul>
          <el-button
            class="billing-action-button"
            :class="{ 'is-selected': selectedPackageId === item.id }"
            round
            @click.stop="submitPackage(item)"
          >
            {{ selectedPackageId === item.id ? (isDayCard(item) ? '立即开通' : '立即充值') : '选择套餐' }}
          </el-button>
        </article>
      </section>
      <p v-else class="billing-empty">暂无可用套餐。</p>
    </article>
  </section>
</template>

<script>
import { fetchBillingDashboard } from '../../api/billing';

export default {
  name: 'BillingView',
  data() {
    return {
      loading: false,
      selectedPackageId: '',
      balancePackages: [],
      dayCardPackages: []
    };
  },
  created() {
    this.loadDashboard();
  },
  methods: {
    isDayCard(item) {
      return item && item.groupType === 'MONTH_CARD';
    },
    getFeatures(item) {
      return this.isDayCard(item) ? this.getDayCardFeatures(item) : this.getBalanceFeatures(item);
    },
    async loadDashboard() {
      this.loading = true;
      try {
        const { data } = await fetchBillingDashboard();
        if (!data || data.code !== 0 || !data.data) {
          throw new Error((data && data.message) || 'BILLING_LOAD_FAILED');
        }
        this.balancePackages = Array.isArray(data.data.balancePackages) ? data.data.balancePackages : [];
        this.dayCardPackages = Array.isArray(data.data.dayCardPackages) ? data.data.dayCardPackages : [];

        if (!this.selectedPackageId && this.packages.length) {
          this.selectedPackageId = this.packages[0].id;
        }
      } catch (error) {
        this.balancePackages = [];
        this.dayCardPackages = [];
        this.$message.error(error.message || '充值页面数据加载失败');
      } finally {
        this.loading = false;
      }
    },
    submitPackage(item) {
      if (!item) {
        return;
      }
      if (item.purchaseUrl && String(item.purchaseUrl).trim()) {
        window.open(String(item.purchaseUrl).trim(), '_blank', 'noopener,noreferrer');
        return;
      }
      this.$message.warning('请联系客服充值或者开通');
    },
    getBalanceFeatures(item) {
      const features = [];
      features.push('到账金额：' + this.formatUsdAmount(item.grantAmount));
      features.push('长期有效');
      return features;
    },
    getDayCardFeatures(item) {
      const features = [];
      const validDays = Number(item.validDays || 0);
      if (validDays > 0) {
        features.push('有效时长：' + validDays + '天');
      }
      features.push('每日额度：' + this.formatUsdAmount(item.grantAmount));
      features.push('有效期总额度：' + this.formatUsdAmount(item.totalAmount || item.grantAmount));
      features.push('每日额度按自然日重置');
      features.push('有效期总额度用完后停止使用');
      return features;
    },
    formatPrice(value) {
      return '\uFFE5' + Number(value || 0).toFixed(2);
    },
    formatUsdAmount(value) {
      return '$' + Number(value || 0).toFixed(4);
    }
  },
  computed: {
    packages() {
      return this.balancePackages.concat(this.dayCardPackages);
    }
  }
};
</script>
